if (!customElements.get("m-featured-collection")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      ((this.selectors = {
        loadMoreBtn: "[data-load-more]",
        loadMoreBtnWrapper: ".m-featured-collection__button",
        productsContainer: "[data-products-container]",
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        availableNumber: ["[data-available-number]"],
        countDown: "[data-flashsale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.buttonType = this.dataset.buttonType),
        (this.infiniteLoad = this.dataset.infiniteLoad),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.showPagination = "true" === this.dataset.showPagination),
        (this.showNavigation = "true" === this.dataset.showNavigation),
        (this.enableFlashsale = "true" === this.dataset.enableFlashsale),
        (this.enableCountdown = "true" === this.dataset.enableCountdown),
        (this.id = this.dataset.id),
        (this.items = this.dataset.items),
        (this.mobileDisableSlider =
          "true" === this.dataset.mobileDisableSlider),
        this.dataset.filteredUrl
          ? this.fetchFilteredProducts()
          : this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        }),
        this.enableFlashsale && this.initFlashSale(),
        (this.canLoad = !0),
        (this.currentPage = 1),
        (this.spinner = spinner()),
        this.enableSlider ||
          "load" !== this.buttonType ||
          "true" !== this.infiniteLoad ||
          this.initInfiniteLoad(),
        this.enableSlider || "load" !== this.buttonType || this.initLoadMore(),
        MinimogTheme.config.mqlMobile &&
          this.mobileDisableSlider &&
          "load" === this.buttonType &&
          "true" === this.infiniteLoad &&
          this.initInfiniteLoad(),
        MinimogTheme.config.mqlMobile &&
          this.mobileDisableSlider &&
          "load" === this.buttonType &&
          this.initLoadMore(),
        document.addEventListener("matchMobile", () => {
          (MinimogTheme.config.mqlMobile &&
            this.mobileDisableSlider &&
            "load" === this.buttonType &&
            this.initLoadMore(),
            MinimogTheme.config.mqlMobile &&
              this.mobileDisableSlider &&
              "load" === this.buttonType &&
              "true" === this.infiniteLoad &&
              this.initInfiniteLoad());
        }));
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this,
      );
      MinimogTheme.config.mqlMobile && this.mobileDisableSlider
        ? (t && t.classList.add("m:hidden"),
          e && e.classList.remove("swiper-container"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t && t.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e } = queryDomNodes(this.selectors, this),
        t = this.querySelector(".m-slider-controls"),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next"),
        o = e.querySelector(".swiper-wrapper").childElementCount;

      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
      }

      (e && e.classList.add("swiper-container"),
        (this.slider = new MinimogLibs.Swiper(e, {
          slidesPerView: 2,
          showPagination: this.showPagination,
          showNavigation: this.showNavigation,
          loop: false,
          pagination: !!this.showPagination && {
            el: this.querySelector(".swiper-pagination"),
            clickable: !0,
          },
          breakpoints: {
            768: {
              slidesPerView:
                parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
            },
            1024: {
              slidesPerView:
                parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
            },
            1280: { slidesPerView: parseInt(this.items) },
          },
          threshold: 2,
          on: {
            init: () => {
              setTimeout(() => {
                const e =
                  this.querySelector(".m-image") ||
                  this.querySelector(".m-placeholder-svg");
                if (e && t) {
                  const o = e.clientHeight;
                  (t.style.setProperty("--offset-top", parseInt(o) / 2 + "px"),
                    i && i.classList.remove("m:hidden"),
                    s && s.classList.remove("m:hidden"));
                }
              }, 200);
            },
            breakpoint: (e, i) => {
              if (t) {
                const { slidesPerView: s } = i;
                o > s
                  ? (t.classList.remove("m:hidden"), (e.allowTouchMove = !0))
                  : (t.classList.add("m:hidden"), (e.allowTouchMove = !1));
              }
            },
          },
        })),
        this.slider &&
          this.showNavigation &&
          (i && i.addEventListener("click", () => this.slider.slidePrev()),
          s && s.addEventListener("click", () => this.slider.slideNext())),
        (this.swiper = e && e.swiper));
    }
    initLoadMore() {
      ((this.triggerLoad = !1),
        (this.totalPages = parseInt(this.dataset.totalPages)),
        addEventDelegate({
          context: this.container,
          selector: this.selectors.loadMoreBtn,
          handler: (e) => {
            (e.preventDefault(), this.handleLoadMore());
          },
        }));
    }
    initInfiniteLoad() {
      const e = this.dataset.maxPages;
      window.addEventListener("scroll", (t) => {
        ((this.canLoad = this.currentPage < parseInt(e)),
          this.canLoad &&
            this.offsetTop + this.clientHeight - window.innerHeight <
              window.scrollY &&
            !this.triggerLoad &&
            ((this.triggerLoad = !0), this.handleLoadMore()));
      });
    }
    async handleLoadMore() {
      (this.currentPage++,
        (this.canLoad = this.currentPage < this.totalPages),
        this.toggleLoading(!0));
      const e = this.dataset.collectionId,
        t = await fetchCountDown(e),
        i = `${this.dataset.url}?page=${this.currentPage}&section_id=${this.id}`;
      fetchCache(i).then((e) => {
        this.toggleLoading(!1);
        const i = generateDomFromString(e).querySelector(
            this.selectors.productsContainer,
          ),
          s = this.domNodes.productsContainer.childElementCount;
        let o = !1;
        if (
          (i &&
            Array.from(i.childNodes).forEach((e) => {
              this.domNodes.productsContainer.appendChild(e);
              const t = setInterval(() => {
                this.domNodes.productsContainer.childElementCount > s &&
                  (clearInterval(t), (o = !0));
              }, 50);
            }),
          this.enableFlashsale && t.ok && t.payload && t.payload.length)
        ) {
          const { expires_date: e } = t.payload[0];
          this.expires_date = e;
          const i = setInterval(() => {
            if (o) {
              clearInterval(i);
              this.domNodes.productsContainer
                .querySelectorAll(".m-product-card")
                .forEach((e) => {
                  const i = e.querySelector(".m-product-card__content");
                  if (!e.querySelector(".m-product-sale-progress")) {
                    let s;
                    e.dataset.soldNumber && (s = e.dataset.soldNumber);
                    const o = saleProgress(
                        t.payload[0],
                        e.dataset.productId,
                        s,
                      ),
                      a = generateDomFromString(o);
                    i.appendChild(a);
                  }
                });
            }
          }, 50);
        }
        ((this.triggerLoad = !1),
          this.canLoad ||
            (this.domNodes.loadMoreBtn &&
              this.domNodes.loadMoreBtn.classList.add("m:hidden")));
      });
    }
    toggleLoading(e) {
      this.domNodes.loadMoreBtn &&
        (e
          ? this.domNodes.loadMoreBtn.classList.add("m-spinner-loading")
          : this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading"));
    }
    async initFlashSale() {
      const e = this.dataset.collectionId,
        t = await fetchCountDown(e);
      if (t.ok && t.payload && t.payload.length) {
        const { expires_date: e } = t.payload[0];
        ((this.expires_date = e),
          this.domNodes.products.forEach((e) => {
            const i = e.querySelector(".m-product-card__content"),
              s = e.querySelector(".m-product-sale-progress");
            let o;
            e.dataset.soldNumber && (o = e.dataset.soldNumber);
            const a = saleProgress(t.payload[0], e.dataset.productId, o),
              n = generateDomFromString(a);
            s || i.appendChild(n);
          }),
          this.initCountDown());
      }
    }
    initCountDown() {
      const e = new Date(this.expires_date).getTime();
      this.countDownTimer = new CountdownTimer(
        this.domNodes.countDown,
        Date.now(),
        e,
        { loop: !0 },
      );
    }
    async fetchFilteredProducts() {
      let url = this.dataset.filteredUrl;
      const limit = parseInt(this.dataset.productLimit) || 8;
      const container = this.domNodes.productsContainer || this.querySelector("[data-products-container]");

      if (!container) {
        console.warn("Products container not found.");
        return;
      }

      if (!url) {
        console.warn("No filtered URL provided.");
        return;
      }

      console.log("--- fetchFilteredProducts Started ---");
      
      // Normalize URL: if it's an absolute URL for the same store or has ackermans in the domain, make it relative to avoid CORS
      if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
        try {
          const urlObj = new URL(url);
          if (urlObj.hostname.includes("ackermans") || urlObj.hostname === window.location.hostname) {
            url = urlObj.pathname + urlObj.search;
            console.log("Normalized URL to relative:", url);
          }
        } catch (e) {
          console.warn("Could not normalize URL:", e);
        }
      }

      // Check if it's an Unbxd URL
      const isUnbxd = url.includes('filter=') || url.includes('p=category_handle') || url.includes('rows=') || url.includes('q=');
      
      if (!isUnbxd) {
        console.log("Not an Unbxd URL. Using standard Liquid rendered products.");
        this.initByScreenSize();
        return;
      }
      
      try {
        let products = [];

        if (isUnbxd) {
          console.log("Unbxd URL detected. Fetching via Unbxd API...");
          
          const urlObj = new URL(url, window.location.origin);
          let p = urlObj.searchParams.get('p');
          const filters = urlObj.searchParams.getAll('filter');
          const q = urlObj.searchParams.get('q');
          const rows = urlObj.searchParams.get('rows') || 50;
          
          if (!p && !q && urlObj.pathname.includes('/collections/')) {
            const handle = urlObj.pathname.split('/collections/')[1].split('/')[0].split('?')[0];
            p = `category_handle:"${handle}"`;
          }
          
          // Retrieve the unbxd.userId cookie for personalization matching
          let uid = "";
          try {
            const getUidCookie = document.cookie.match("\\bunbxd.userId=([^;]*)\\b");
            uid = getUidCookie ? getUidCookie[1] : "";
          } catch (e) {
            console.warn("Could not read unbxd.userId cookie:", e);
          }
          
          // Hardcode known good keys to avoid issues with dynamic window values
          const siteKey = 'ss-unbxd-auk-prod-ackermans69821759306654';
          const apiKey = '828483554c8171777f4e42b2a5fac055';
          
          // Determine whether to use search or category endpoint to ensure correct merchandising sorting
          let apiUrl;
          const isCategoryPage = !q && (p || urlObj.pathname.includes('/collections/'));

          if (isCategoryPage) {
            apiUrl = `https://search.unbxd.io/${apiKey}/${siteKey}/category?format=json&version=V2&rows=${rows}&t=${Date.now()}`;
            
            // Normalize p value for category browse endpoint
            let categoryParam = p || "";
            if (categoryParam) {
              if (!categoryParam.includes('category_handle:')) {
                categoryParam = `category_handle:"${categoryParam}"`;
              }
            } else if (urlObj.pathname.includes('/collections/')) {
              const handle = urlObj.pathname.split('/collections/')[1].split('/')[0].split('?')[0];
              categoryParam = `category_handle:"${handle}"`;
            }
            
            apiUrl += `&p=${encodeURIComponent(categoryParam)}`;
            apiUrl += `&pagetype=boolean`;
          } else {
            apiUrl = `https://search.unbxd.io/${apiKey}/${siteKey}/search?format=json&version=V2&rows=${rows}&t=${Date.now()}`;
            if (q) {
              apiUrl += `&q=${encodeURIComponent(q)}`;
            } else {
              apiUrl += `&q=*`;
            }
            if (p) {
              if (p.includes('category_handle:')) {
                apiUrl += `&filter=${encodeURIComponent(p)}`;
              } else {
                apiUrl += `&filter=${encodeURIComponent('category_handle:"' + p + '"')}`;
              }
            }
          }

          if (uid) {
            apiUrl += `&uid=${encodeURIComponent(uid)}`;
          }
          apiUrl += `&user.behaviour=true&enablePopularity=true`;
          
          if (filters && filters.length > 0) {
            filters.forEach(f => {
              apiUrl += `&filter=${encodeURIComponent(f)}`;
            });
          }

          console.log("Unbxd API Request:", apiUrl);

          const unbxdResponse = await fetch(apiUrl);
          if (!unbxdResponse.ok) {
            throw new Error(`Unbxd API request failed: ${unbxdResponse.status} ${unbxdResponse.statusText}`);
          }
          
          const unbxdData = await unbxdResponse.json();
          console.log("Full Unbxd Data:", unbxdData);
          
          const responseData = unbxdData.response || {};
          const unbxdProducts = responseData.products || responseData.docs || [];
          const unbxdIds = [...new Set(unbxdProducts.map(prod => String(prod.uniqueId)))];
          const unbxdHandles = unbxdProducts.map(prod => String(prod.handle || ''));
          
          console.log("Unbxd Results:", unbxdProducts.length, "products found. Unique:", unbxdIds.length);

          if (unbxdIds.length > 0) {
            const shopifyUrl = url;
            console.log("Fetching Shopify HTML with filters from:", shopifyUrl);
            const shopifyResponse = await fetch(shopifyUrl);
            if (shopifyResponse.ok) {
              const html = await shopifyResponse.text();
              const doc = new DOMParser().parseFromString(html, "text/html");
              const allItems = Array.from(doc.querySelectorAll('.m-product-card, .product-card, .product-item'));
              console.log("Shopify Cards on base page:", allItems.length);
              
              // Match by ID or Handle, ensuring unique nodes
              const matchedNodes = new Set();
              const productsById = new Map();
              const productsByHandle = new Map();

              // Map existing items for quick lookup
              allItems.forEach(item => {
                const itemId = item.dataset.productId || item.getAttribute('data-id');
                const itemHandleBtn = item.querySelector('[data-product-handle]');
                let itemHandle = itemHandleBtn ? itemHandleBtn.dataset.productHandle : '';
                if (!itemHandle) {
                  const link = item.querySelector('a[href*="/products/"]');
                  if (link) {
                    const href = link.getAttribute('href');
                    const match = href.match(/\/products\/([^/?]+)/);
                    if (match) itemHandle = match[1];
                  }
                }
                
                if (itemId) productsById.set(String(itemId), item);
                if (itemHandle) productsByHandle.set(String(itemHandle), item);
              });

              const productsToInject = [];
              const fetchPromises = [];

              console.log(`Searching for ${Math.min(unbxdIds.length, limit)} products in ${allItems.length} base cards...`);

              for (let i = 0; i < unbxdIds.length && productsToInject.length + fetchPromises.length < limit; i++) {
                const id = String(unbxdIds[i]);
                const handle = String(unbxdHandles[i] || '');
                
                let matchedNode = productsById.get(id) || productsByHandle.get(id) || (handle ? productsByHandle.get(handle) : null);
                
                if (matchedNode && !matchedNodes.has(matchedNode)) {
                  matchedNodes.add(matchedNode);
                  productsToInject.push({ index: i, node: matchedNode });
                } else if (handle) {
                  // Not found in base page, fetch individually
                  console.log(`Product ${handle} (ID: ${id}) not found in base page, will fetch individually.`);
                  fetchPromises.push((async (idx, h) => {
                    try {
                      const resp = await fetch(`/products/${h}?view=grid-card-item`);
                      if (resp.ok) {
                        const text = await resp.text();
                        const cardDoc = new DOMParser().parseFromString(text, 'text/html');
                        const card = cardDoc.querySelector('.m-product-card, .product-card, .product-item');
                        if (card) return { index: idx, node: card };
                      }
                    } catch (e) {
                      console.error(`Error fetching product ${h}:`, e);
                    }
                    return null;
                  })(i, handle));
                }
              }

              if (fetchPromises.length > 0) {
                const fetchedResults = await Promise.all(fetchPromises);
                fetchedResults.filter(Boolean).forEach(res => productsToInject.push(res));
              }

              // Sort back to original Unbxd order
              productsToInject.sort((a, b) => a.index - b.index);
              products = productsToInject.map(p => p.node);
              
              console.log(`Matched/Fetched ${products.length} products total.`);
            }
          }
        }



        if (products.length === 0) {
          console.warn("No products found.");
          container.innerHTML = '<div class="m-no-products m:text-center m:py-10 m:w-full" style="grid-column: 1/-1;">No Matching Products Found</div>';
          return;
        }

        console.log(`Injecting ${Math.min(products.length, limit)} products.`);
        container.innerHTML = "";
        products.slice(0, limit).forEach(product => {
          const slide = document.createElement("div");
          slide.className = "swiper-slide m:column";
          slide.appendChild(product);
          container.appendChild(slide);
        });

        this.initByScreenSize();
        console.log("--- fetchFilteredProducts Completed ---");
      } catch (error) {
        console.error("Error in fetchFilteredProducts:", error);
      } finally {
        const loading = this.querySelector(".m-featured-collection__loading");
        if (loading) loading.style.display = "none";
      }
    }
  }
  customElements.define("m-featured-collection", e);
}
